import PropTypes from 'prop-types';
import { useRouter } from 'next/router';

import { useSelector } from 'react-redux';
import { AUTH_STATE, selectAuthState } from '@/modules/session/auth.slice';
import { useQueryParams } from '@/utilities/reusable-functions/query-params-util';

const UnauthenticatedLayout = ({ children }) => {
  const router = useRouter();
  const authState = useSelector(selectAuthState);

  const { getQueryParams } = useQueryParams();

  if (authState === AUTH_STATE.LOGGED_IN && router.isReady) {
    if (router.query?.redirect) router.push(router.query.redirect);
    else {
      // eslint-disable-next-line no-console
      console.log('success');
      router.push(`/orders${getQueryParams()}`);
    }
  }

  return children;
};
UnauthenticatedLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default UnauthenticatedLayout;
